import React from 'react'
import Astrologer_after_Login_Header from '../astrologer_after_login_header/Astrologer_after_Login_Header'
import Astrologer_Footer from '../astrologer_footer/Astrologer_Footer'

const Astrologer_Calling_History = () => {
    return (
        <div>
            {/*  */}
            <Astrologer_after_Login_Header />
            <section className="gi-product-tab gi-products py-[30px] pb-[60px] max-[767px]:py-[30px] wow fadeInUp"
                data-wow-duration="2s">
                <div
                    className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5">
                    <div className="gi-tab-title w-full inline-flex justify-between px-[12px] max-[991px]:flex-col items-center">
                        <div className="gi-main-title">
                            <div className="section-title mb-[20px] pb-[20px] flex ">
                                <div className="section-detail">
                                    <h2
                                        className="gi-title mb-[0] text-[25px] max-[991px]:text-[24px] max-[767px]:text-[22px] max-[575px]:text-[20px] font-semibold text-[#4b5966] relative inline p-[0]  leading-[1] font-Poppins tracking-[0.01rem]">
                                        Calling History</h2>

                                </div>
                            </div>
                        </div>

                        <div className="gi-pro-tab max-[991px]:mt-[-20px] max-[991px]:mb-[30px]">
                            <a href="#"
                                className="text-red-700 hover:text-white border border-red-900 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900">See
                                View All</a>
                        </div>

                    </div>

                    <div className="w-full mb-[-24px]">
                        <div
                            className="custome_jewellery grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-6 px-[15px]">
                            <div className="border rounded-lg p-4 bg-white">
                                <div className="flex justify-between">
                                    <div>
                                        <h5 className="text-lg font-medium text-black">Repeat Indian</h5>
                                        <p className="text-[#EDA801] text-sm">Loyal User offer(30%)</p>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <h5 className="text-lg font-medium text-black">Rs. 45.0</h5>
                                        <a href="#"><img src="../assets/img/icons/report_icon2.png" alt="" /></a>
                                    </div>
                                </div>
                                <div className="shadow rounded-md p-4 mt-3">
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <span className="text-sm text-gray-700">Order ID</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">#75487545</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Name</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Rahul Sharma</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Gender</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Male</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">DOB</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">14/07/1995</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Pob</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Sundargarh, Odisha, India</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Order Time</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">6 October 24, 3:55Am</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Duration</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">10 Minutes</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Rate</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Rs. 8.5/Minute</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Status</span>
                                            <h5 className="text-[14px] text-green-800 font-medium">Complete</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Order</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Omens User</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">User Type</span>
                                            <h5 className="text-[14px] text-red-600 font-medium">Loyal User</h5>
                                        </div>
                                        <div>
                                            <a href="#"
                                                className="text-red-700 hover:text-white border border-red-900 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-full text-sm px-5 py-2 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 inline-block">Open
                                                Kundli</a>
                                        </div>


                                    </div>
                                    <div>
                                        <span
                                            className="whitespace-nowrap inline-block text-gray-900 hover:text-white border hover:bg-gray-900 rounded-full text-sm px-5 py-2 text-center mt-2">Assistant
                                            Chat</span>
                                        <span
                                            className="whitespace-nowrap inline-block text-gray-900 hover:text-white border hover:bg-gray-900 rounded-full text-sm px-5 py-2 text-center mt-2">Suggest
                                            Remedy</span>
                                    </div>
                                </div>
                            </div>
                            <div className="border rounded-lg p-4 bg-white">
                                <div className="flex justify-between">
                                    <div>
                                        <h5 className="text-lg font-medium text-black">Repeat Indian</h5>
                                        <p className="text-[#EDA801] text-sm">Loyal User offer(30%)</p>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <h5 className="text-lg font-medium text-black">Rs. 45.0</h5>
                                        <a href="#"><img src="../assets/img/icons/report_icon2.png" alt="" /></a>
                                    </div>
                                </div>
                                <div className="shadow rounded-md p-4 mt-3">
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <span className="text-sm text-gray-700">Order ID</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">#75487545</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Name</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Rahul Sharma</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Gender</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Male</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">DOB</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">14/07/1995</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Pob</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Sundargarh, Odisha, India</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Order Time</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">6 October 24, 3:55Am</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Duration</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">10 Minutes</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Rate</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Rs. 8.5/Minute</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Status</span>
                                            <h5 className="text-[14px] text-green-800 font-medium">Complete</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Order</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Omens User</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">User Type</span>
                                            <h5 className="text-[14px] text-red-600 font-medium">Loyal User</h5>
                                        </div>
                                        <div>
                                            <a href="#"
                                                className="text-red-700 hover:text-white border border-red-900 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-full text-sm px-5 py-2 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 inline-block">Open
                                                Kundli</a>
                                        </div>


                                    </div>
                                    <div>
                                        <span
                                            className="whitespace-nowrap inline-block text-gray-900 hover:text-white border hover:bg-gray-900 rounded-full text-sm px-5 py-2 text-center mt-2">Assistant
                                            Chat</span>
                                        <span
                                            className="whitespace-nowrap inline-block text-gray-900 hover:text-white border hover:bg-gray-900 rounded-full text-sm px-5 py-2 text-center mt-2">Suggest
                                            Remedy</span>
                                    </div>
                                </div>
                            </div>
                            <div className="border rounded-lg p-4 bg-white">
                                <div className="flex justify-between">
                                    <div>
                                        <h5 className="text-lg font-medium text-black">Repeat Indian</h5>
                                        <p className="text-[#EDA801] text-sm">Loyal User offer(30%)</p>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <h5 className="text-lg font-medium text-black">Rs. 45.0</h5>
                                        <a href="#"><img src="../assets/img/icons/report_icon2.png" alt="" /></a>
                                    </div>
                                </div>
                                <div className="shadow rounded-md p-4 mt-3">
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <span className="text-sm text-gray-700">Order ID</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">#75487545</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Name</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Rahul Sharma</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Gender</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Male</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">DOB</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">14/07/1995</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Pob</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Sundargarh, Odisha, India</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Order Time</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">6 October 24, 3:55Am</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Duration</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">10 Minutes</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Rate</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Rs. 8.5/Minute</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Status</span>
                                            <h5 className="text-[14px] text-green-800 font-medium">Complete</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">Order</span>
                                            <h5 className="text-[14px] text-[#0F1726] font-medium">Omens User</h5>
                                        </div>
                                        <div>
                                            <span className="text-sm text-gray-700">User Type</span>
                                            <h5 className="text-[14px] text-red-600 font-medium">Loyal User</h5>
                                        </div>
                                        <div>
                                            <a href="#"
                                                className="text-red-700 hover:text-white border border-red-900 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-full text-sm px-5 py-2 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 inline-block">Open
                                                Kundli</a>
                                        </div>
                                    </div>
                                    <div>
                                        <span
                                            className="whitespace-nowrap inline-block text-gray-900 hover:text-white border hover:bg-gray-900 rounded-full text-sm px-5 py-2 text-center mt-2">Assistant
                                            Chat</span>
                                        <span
                                            className="whitespace-nowrap inline-block text-gray-900 hover:text-white border hover:bg-gray-900 rounded-full text-sm px-5 py-2 text-center mt-2">Suggest
                                            Remedy</span>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>
            {/*  */}
            <Astrologer_Footer />
        </div>
    )
}

export default Astrologer_Calling_History